<template>
    <div class="alarm-card">
        <div v-if="type === 'edit'" class="alarm-card__edit-alarm">
            <div class="flex-wrapp">
                <div class="alarm-card__header">
                    <div class="wrapper header-wrapper">
                        <h5 class="alarm-card__title"> {{ alarm.alarmKey }} </h5>
                        <div v-if="alarm.pipelines.length === 1" class="alarm-card__subtitle"> {{ decodeAlarmPipeline }} </div>
                    </div>
                </div>
                <div class="alarm-card__details">
                    <div v-if="alarm.pipelines.length === 1" class="wrapper details-wrapper">
                        <div v-if="alarm.pipelines[0].type === 1">
                            <div class="alarm-card__details__row">
                                <span class="alarm-card__details__name">Classification: </span>
                                <span>{{ decodeEventClassification }}</span>
                            </div>
                            <div class="alarm-card__details__row">
                                <span class="alarm-card__details__name">Event Type: </span>
                                <span> {{ decodeEventType }} </span>
                            </div>
                        </div>
                        <div v-if="alarm.pipelines[0].type === 3">
                            <div class="alarm-card__details__row">
                                <span class="alarm-card__details__name">Recipients: </span>
                                <span>{{ decodeRecipients }}</span>
                            </div>
                            <div class="alarm-card__details__row hidden">
                                <span class="alarm-card__details__name">Event Type: </span>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="alarm.pipelines.length === 0" class="wrapper details-wrapper">
                        <div class="alarm-card__details__row">
                            <p class="alarm-card__details__compounded"> Alarm with no actions </p>
                        </div>
                    </div>
                    <div v-else class="wrapper details-wrapper">
                        <div class="alarm-card__details__row">
                            <p class="alarm-card__details__compounded"> Compound workflow </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="alarm-card__footer">
                <div class="wrapper footer-wrapper">
                    <sp-btn text="Edit Alarm" @click.native="onEditAlarm" icon="settings"></sp-btn>
                    <sp-btn v-if="alarm.isOverriden" text="Reset" @click.native="onResetAlarm" icon="reset"></sp-btn>
                </div>
            </div>
        </div>
        <div
            v-if="type === 'add'"
            class="alarm-card__add-alarm"
            @click="onEditAlarm"
        >
            <icon class="alarm-card__add-alarm__icon" icon="add" color="red" :width="30" :height="30"/>
            <p class="alarm-card__add-alarm__info">
                Add New Device Alarm
            </p>
        </div>
    </div>
</template>

<script>

import SpBtn from '@/components/forms/SpBtn'
import { searchEnumById } from '@/helpers/Utils'
import Icon from '@/components/atoms/Icon'

import { mapGetters } from 'vuex'

export default {
    name: 'DeviceAlarmCard',
    components: {
        SpBtn,
        Icon
    },
    mounted () {
    },
    computed: {
        ...mapGetters({
            getEventClassifications: 'dictionaryModule/getEventClassifications',
            getEventTypes: 'dictionaryModule/getEventTypes',
            getAlarmPipelines: 'dictionaryModule/getAlarmPipelines'
        }),
        decodeEventType () {
            return searchEnumById(this.getEventTypes, this.alarm.pipelines[0].eventType)
        },
        decodeEventClassification () {
            return searchEnumById(this.getEventClassifications, this.alarm.pipelines[0].eventClassification)
        },
        decodeAlarmPipeline () {
            return searchEnumById(this.getAlarmPipelines, this.alarm.pipelines[0].type)
        },
        decodeRecipients () {
            return this.alarm.pipelines[0].recipients.join(', ')
        }
    },
    props: {
        alarm: {
            type: [Object, Array],
            required: true
        },
        type: {
            type: [String, null],
            required: true
        }
    },
    methods: {
        onEditAlarm () {
            this.$emit('isAlarmProcessed', this.alarm)
        },
        onResetAlarm () {
            this.$emit('resetAlarm', this.alarm)
        }
    }
}
</script>

<style lang="scss" scoped>
.alarm-card {
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(153, 157, 169, 0.75);
    &__edit-alarm{
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    &__title {
        font-size: 16px;
    }
    &__subtitle {
        font-size: 14px;
    }
    &__details{
        font-size: 14px;
        &__name {
            font-weight: bold;
        }
        &__row {
            padding: 5px 0;
        }
        &__compounded {
            text-align: center;
            font-weight: 600;
            margin: 26px 0;
        }
    }
    .header-wrapper {
        padding: 20px 20px 10px 20px;
        margin: 0 0 7px 0;
    }
    .details-wrapper {
        padding: 0 20px;
        margin: 0 0 10px 0;
    }
    .footer-wrapper {
        background: $light-gray;
        padding: 10px 20px;
        display: flex;
        align-self: flex-end;
        align-items: center;
        justify-content: space-between;
        flex-direction: row-reverse;
    }
}

.hidden {
    visibility: hidden;
}

.alarm-card__add-alarm {
    display: flex;
    height: 100%;
    min-height: 224px;
    border-radius: 8px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: lighten($inactive, 30%);
    cursor: pointer;
    transition: background .1s ease-in-out;
    &:hover {
        background: lighten($inactive, 20%);
    }
    &__info {
        display: block;
        margin: 0;
        font-weight: bold;
    }
    &__icon {
        display: block;
        margin-bottom: 10px;
    }
}
</style>
